export default "__VITE_ASSET__7e607a21__"